import { render } from "./Main-header.vue?vue&type=template&id=ce12fb22&scoped=true"
import script from "./Main-header.vue?vue&type=script&lang=js"
export * from "./Main-header.vue?vue&type=script&lang=js"

import "./Main-header.vue?vue&type=style&index=0&id=ce12fb22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce12fb22"]])

export default __exports__